// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__37bLd","content":"styles_content__1eXYg","selectAll":"styles_selectAll__2xxzu"};